import top from "./top"

export default class Weights1 extends Component {
  render() {
    const size = 300
    const grid = [
      [0, 0, 0, 0.1, 0],
      [0, 0.5, 1, 0.3, 0.2],
      [0.5, 1, 0.7, 0, 0],
      [0.5, 0.1, 0, 0, 0],
      [0.2, 0, 0, 0, 0],
    ]

    const tileSize = size / grid.length

    return (
      <Surface alignItems="center" margin={20}>
        {top}
        <Surface
          width={size}
          height={size}
          marginTop={40}
          overflow="hidden"
          background="rgba(0, 0, 0, 0.08)"
          style={{ border: "1px solid rgba(0, 0, 0, 0.2)" }}
          borderRadius={5}
        >
          {grid.map(row => (
            <Surface flexFlow="row">
              {row.map(col => (
                <Surface
                  position="relative"
                  opacity={col}
                  width={tileSize}
                  height={tileSize}
                >
                  <img
                    src={require("./curve.png")}
                    width={tileSize * 2}
                    height={tileSize * 2}
                    style={{
                      position: "absolute",
                      left: 0,
                      top: 0,
                      zIndex: col * 100,
                    }}
                  />
                </Surface>
              ))}
            </Surface>
          ))}
        </Surface>
        <Text fontStyle="italic" width={380} textAlign="center" marginTop={10}>
          At each point along the curve, the curve detector is looking for a
          “tangent curve” using the earlier curve detector
        </Text>
      </Surface>
    )
  }
}
